import type { Basis } from "../types/pl";

interface BasisBadgeProps {
  basis: Basis;
  note?: string;
  /** pl_settings.confirmed=false 由来の値（料率未確認など）。basisより優先して「未確認」を出す。 */
  unconfirmed?: boolean;
}

/** 見込み(estimate)＝琥珀「見込み」、mixed＝「一部見込み」、confirmed=false由来＝「未確認」。actual/noneは無表示。 */
export function BasisBadge({ basis, note, unconfirmed }: BasisBadgeProps) {
  if (unconfirmed) {
    return (
      <span className="pl-badge pl-badge--unconfirmed" title={note}>
        未確認
      </span>
    );
  }
  if (basis === "actual" || basis === "none") return null;
  const label = basis === "estimate" ? "見込み" : "一部見込み";
  return (
    <span className="pl-badge pl-badge--estimate" title={note}>
      {label}
    </span>
  );
}
